import { Component } from '../../../dispatcher/modules';
import { Position } from '../../../dispatcher/Types';
import { ABSTRACT_BASE_FORM_PROPS } from './Types';

export default abstract class AbstractBaseForm<P = {}, S = {}> extends Component<P & ABSTRACT_BASE_FORM_PROPS, S> {
  isFormValid:boolean = false;
  resourceExists:any = {};

  /**
   * Call dispatch action for change button config (disable/enable) from dialog -
   * (You must create that dispatch action and put props on your class (e.g. disableEnableActionName={'enableDisableCreateTmGroupButton'}))
   *
   * e.g.
   * export const enableDisableCreateTmGroupButton: Action = [{
   *   buttons: [{
   *     disabled: '!{isValid}',
   *     name: 'CreateTmGroups.create'
   *   }],
   *   dialogName: 'CreateTmGroups',
   *   type: OperationType.updateDialog
   * }];
   *
   * Use this method with handleChange
   * e.g.
   * onChange={(e: InputChangeEvent) => handleChange(e, this.onAllValidation)}
   */
  onAllValidation = () => {
    const { isAllFieldValid } = this.props.form;
    const isValid = isAllFieldValid();

    if (this.isFormValid !== isValid) {
      this.isFormValid = isValid;
      this.dispatch(this.props.disableEnableActionName, Position.end, {
        isValid
      });
    }
  }

  /**
   * Listener from PuzzleInputWithExistingValidation component
   * @param {boolean} resourceExists
   * @param {string} name
   * @param {string} value
   */
  getFieldValidation = (resourceExists: boolean, name:string, value:string) => {
    this.resourceExists[name] = resourceExists;
  }

  /**
   * Create a method with updateFormFields name for update fields with this method
   * @param {any} response
   */
  updateFormFields = (response: any) => {}
}
